import { CesiumZone } from 'app/map/geometry/cesium/CesiumZones/CesiumZone';
import { Destroyable } from 'app/shared/utilities/Destructor';

interface CesiumZones {
    [id: number]: CesiumZone;
}

export class CesiumZoneCollection implements Destroyable {
    private _cesiumZones: CesiumZones;
    constructor() {
        this._cesiumZones = {};
    }

    public get(zoneId: number) {
        return this._cesiumZones[zoneId];
    }

    public get zones(): CesiumZones {
        return this._cesiumZones;
    }

    public set zones(cesiumZones: CesiumZones) {
        this._cesiumZones = cesiumZones;
    }

    public destroy() {
        this._cesiumZones = {};
    }

    public getAllAsArray(): Array<CesiumZone> {
        return Object.values(this._cesiumZones);
    }
}
